import { get } from './utils';
export const getErrorDescription = reason => get(reason, 'data.error_description', '');
export function toObject(data) {
  if (!data) {
    return null;
  }
  if (typeof data === 'string') {
    if (['{', '['].indexOf(data[0]) >= 0) {
      try {
        return JSON.parse(data);
      } catch (err) {
        return {
          error_code: -100,
          error_description: 'Can`t parse JSON',
          error_info: {
            key: 'wmp_error.cant_parse_json'
          }
        };
      }
    }
    return {
      message: data
    };
  }
  return data;
}
export function toErrorObject(error) {
  const errorDescription = getErrorDescription(error);
  let message;
  if (errorDescription === 'Missing Wix session') {
    message = 'Wix Session required';
  } else if (errorDescription === 'site_token') {
    message = 'Site token has expired';
  } else if (errorDescription === 'Tokens mismatch') {
    message = 'Tokens mismatch';
  } else {
    message = error.statusText || get(error, 'message.description', error.message) || get(error, 'data.message') || get(error, 'data.error.message') || errorDescription || '';
  }
  const errorObject = new Error(message);
  errorObject.code = error.status || error.code;
  errorObject.data = error.data && (error.data.errors || error.data.error || error.data);
  errorObject.config = error.config;
  if (error.name) {
    errorObject.name = error.name;
  }
  return errorObject;
}